import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'psycologists-home',
    component: () => import(/* webpackChunkName: "psycologists" */ '@/layouts/PrincipalLayout.vue'),
    beforeEnter: [isVerifyTokenGuard],
    children: [
        {
            path: '', 
            name: 'psycologists-home-index',
            component: () => import(/* webpackChunkName: "psycologists-home" */ '@/modules/psycologists/home/views/Index.vue')
        }
    ]    
}

